import { basics } from "../../basics";

const NoStockButton = (props: any) => {
  return (
    <div
      className={`text-red-700 bg-red-50 border border-red-100 font-bold rounded-xl flex items-center justify-center text-center ${
        props.large ? "text-base h-11 w-full" : "text-sm min-w-[120px] h-9"
      }`}
    >
      {basics.noStocks}
    </div>
  );
};

export default NoStockButton;
